// Label colours are stored as a palette key, so the colours can change
// without touching saved labels.
export const LABEL_COLORS = {
  amber: { dot: "#e0a100", bg: "#fff1d6", text: "#8a5a00" },
  violet: { dot: "#6f5bd6", bg: "#e8e4fb", text: "#4c3fa8" },
  green: { dot: "#2f9e6a", bg: "#dcf2ea", text: "#1c6b4a" },
  blue: { dot: "#39a8f0", bg: "#dbeefb", text: "#175f8f" },
  rose: { dot: "#d9414b", bg: "#fde2e8", text: "#9a2d4a" },
  teal: { dot: "#1a9aa0", bg: "#d8f1f2", text: "#11656a" },
  orange: { dot: "#e8590c", bg: "#ffe6d5", text: "#9a3b08" },
  gray: { dot: "#8b8e9e", bg: "#f1f2f5", text: "#43465a" },
};

export const LABEL_COLOR_KEYS = Object.keys(LABEL_COLORS);

export const MAX_LABEL_NAME_LENGTH = 32;

export const getLabelColors = (colorKey) =>
  LABEL_COLORS[colorKey] || LABEL_COLORS.gray;

// The next colour not used yet, so new labels look different by default.
export const pickNextLabelColor = (labels) => {
  const used = new Set(labels.map((label) => label.color));
  return LABEL_COLOR_KEYS.find((key) => !used.has(key)) || LABEL_COLOR_KEYS[0];
};

export const sortLabels = (labels) =>
  labels
    .slice()
    .sort((a, b) =>
      (a.name || "").localeCompare(b.name || "", undefined, {
        sensitivity: "base",
      })
    );

export const getTaskLabelIds = (task) =>
  Array.isArray(task?.labelIds) ? task.labelIds : [];
